<template>
    <v-container fluid class="estadistica-container pa-0">
        <!-- Header mejorado con color corporativo -->
        <v-app-bar
            elevation="2"
            dark
            color="#1565c0"
            class="estadistica-header"
        >
            <v-icon large class="mr-3">mdi-chart-line-variant</v-icon>
            <v-toolbar-title class="estadistica-title">
                {{ reporteActivo.length ? obtenerNombreReporteActivo() : 'Módulo de Estadística' }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip
                v-if="!reporteActivo.length"
                small
                dark
                outlined
                class="ma-2"
            >
                <v-icon small left>mdi-calendar-clock</v-icon>
                {{ fechaActual }}
            </v-chip>
            <v-btn
                v-if="reporteActivo.length"
                dark
                outlined
                small
                @click="regresar"
                class="ma-2"
            >
                <v-icon small left>mdi-arrow-left</v-icon>
                Volver
            </v-btn>
        </v-app-bar>

        <v-sheet elevation="1" class="content-sheet">
            <v-row no-gutters class="full-height">
                <!-- Panel lateral de navegación mejorado -->
                <v-col
                    cols="12"
                    md="3"
                    lg="3"
                    xl="3"
                    class="navigation-panel"
                >
                    <v-card
                        elevation="2"
                        class="navigation-card"
                        height="100%"
                    >
                        <div class="navigation-header">
                            <div class="navigation-header-content">
                                <v-icon class="navigation-header-icon" color="#1565c0" size="32">mdi-view-dashboard</v-icon>
                                <div class="navigation-header-text">
                                    <h3 class="navigation-title-text">Catálogo de Reportes</h3>
                                    <p class="navigation-subtitle-text">Seleccione una categoría</p>
                                </div>
                            </div>
                        </div>
                        <v-divider class="navigation-divider"></v-divider>
                        <v-card-text class="navigation-content pa-0">
                    <v-treeview
                                :items="reportesConIconos"
                        open-on-click
                        activatable
                        hoverable
                        item-key="id"
                        :active.sync="reporteActivo"
                                color="#1565c0"
                                class="custom-treeview"
                                :expand-icon="null"
                                :item-children="'children'"
                            >
                                <template v-slot:prepend="{ item, open }">
                                    <v-icon
                                        v-if="item.icon && !item.children"
                                        :color="reporteActivo.includes(item.id) ? '#ffffff' : '#1565c0'"
                                        size="20"
                                        class="treeview-icon"
                                    >
                                        {{ item.icon }}
                                    </v-icon>
                                    <v-icon
                                        v-else-if="item.icon && item.children"
                                        :color="open ? '#1565c0' : '#757575'"
                                        size="22"
                                        class="treeview-category-icon"
                                    >
                                        {{ open ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                                    </v-icon>
                                </template>
                                <template v-slot:label="{ item }">
                                    <div
                                        class="treeview-item"
                                        :class="{
                                            'treeview-item-category': item.children,
                                            'treeview-item-active': reporteActivo.includes(item.id),
                                            'treeview-item-inactive': !reporteActivo.includes(item.id) && !item.children
                                        }"
                                    >
                                        <div v-if="item.children" class="treeview-category-content">
                                            <v-icon
                                                :color="reporteActivo.some(id => item.children && item.children.some(child => child.id === id)) ? '#1565c0' : '#424242'"
                                                size="24"
                                                class="treeview-category-main-icon"
                                            >
                                                {{ item.icon }}
                                            </v-icon>
                                            <span class="treeview-category-name">{{ item.name }}</span>
                                            <v-chip
                                                x-small
                                                :color="reporteActivo.some(id => item.children && item.children.some(child => child.id === id)) ? '#1565c0' : 'grey'"
                                                text-color="white"
                                                class="treeview-item-count"
                                            >
                                                {{ item.children ? item.children.length : 0 }}
                                            </v-chip>
                                        </div>
                                        <div v-else class="treeview-subitem-content">
                                            <span class="treeview-subitem-name">{{ item.name }}</span>
                                        </div>
                                    </div>
                                </template>
                            </v-treeview>
                        </v-card-text>
                        <v-divider class="navigation-footer-divider"></v-divider>
                        <div class="navigation-footer">
                            <v-chip
                                x-small
                                color="#1565c0"
                                text-color="black"
                                outlined
                                class="footer-chip"
                            >
                                <v-icon x-small left>mdi-information-outline</v-icon>
                                {{ totalReportes }} reportes disponibles
                            </v-chip>
                        </div>
                    </v-card>
                </v-col>

                <!-- Panel de contenido principal -->
                <v-col
                    cols="12"
                    md="9"
                    lg="9"
                    xl="9"
                    class="content-panel"
                >
                    <v-card flat class="content-card" height="100%">
                        <!-- Pantalla de Bienvenida Mejorada -->
                        <div v-if="!reporteActivo.length" class="welcome-screen">
                            <div class="welcome-header">
                                <div class="welcome-icon-container">
                                    <v-icon x-large color="#1565c0" class="welcome-main-icon">
                                        mdi-chart-line-variant
                                    </v-icon>
                                </div>
                                <h1 class="welcome-saludo">
                                    Bienvenido al Módulo de Estadística
                                </h1>
                                <p class="welcome-subtitle">
                                    Sistema de Gestión de Reportes y Estadísticas
                                </p>
                                <v-divider class="welcome-divider"></v-divider>
                            </div>

                            <div class="welcome-content">
                                <v-row>
                                    <v-col cols="12" md="8" class="welcome-info">
                                        <v-card elevation="3" class="info-card">
                                            <v-card-title class="info-card-title">
                                                <v-icon color="#1565c0" class="mr-2">mdi-information</v-icon>
                                                Sistema de Gestión Estadística
                                            </v-card-title>
                                            <v-card-text>
                                                <p class="info-text">
                                                    Este módulo le permite acceder a reportes detallados y estadísticas 
                                                    del sistema SECAH. Utilice el panel lateral para navegar entre las 
                                                    diferentes categorías de reportes disponibles.
                                                </p>
                                                <v-list dense>
                                                    <v-list-item>
                                                        <v-list-item-icon>
                                                            <v-icon color="#1565c0" small>mdi-check-circle</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Reportes en tiempo real</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-list-item-icon>
                                                            <v-icon color="#1565c0" small>mdi-check-circle</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Filtros avanzados por fecha</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-list-item-icon>
                                                            <v-icon color="#1565c0" small>mdi-check-circle</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Exportación de datos</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-list-item-icon>
                                                            <v-icon color="#1565c0" small>mdi-check-circle</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Gráficas y visualizaciones</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4" class="welcome-stats">
                                        <v-card elevation="3" class="quick-stats-card">
                                            <v-card-title class="quick-stats-title">
                                                <v-icon color="#1565c0" class="mr-2">mdi-speedometer</v-icon>
                                                Resumen Rápido
                                            </v-card-title>
                                            <v-card-text>
                                                <div class="quick-stat-item" v-for="(stat, index) in estadisticasResumen" :key="index">
                                                    <div class="quick-stat-icon">
                                                        <v-icon :color="stat.color" size="24">
                                                            {{ stat.icon }}
                                                        </v-icon>
                                                    </div>
                                                    <div class="quick-stat-content">
                                                        <div class="quick-stat-value">{{ stat.value }}</div>
                                                        <div class="quick-stat-label">{{ stat.label }}</div>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <div class="welcome-cards">
                                    <v-row>
                                        <v-col cols="12" sm="6" md="3" v-for="(reporte, index) in reportesAccesoRapido" :key="index">
                                            <v-card
                                                elevation="2"
                                                class="acceso-rapido-card"
                                                @click="seleccionarReporteRapido(reporte)"
                                                :class="{ 'card-hover': true }"
                                            >
                                                <v-card-text class="text-center pa-4">
                                                    <v-icon
                                                        :color="reporte.color"
                                                        size="40"
                                                        class="mb-3"
                                                    >
                                                        {{ reporte.icon }}
                                                    </v-icon>
                                                    <div class="acceso-rapido-titulo">{{ reporte.titulo }}</div>
                                                    <div class="acceso-rapido-descripcion">{{ reporte.descripcion }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>

                        <!-- Contenido de Reportes -->
                        <div v-else class="report-content">
                    <transition
                                name="fade-slide"
                        mode="out-in"
                    >
                                <router-view :key="$route.fullPath"/>
                    </transition>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-sheet>
    </v-container>
</template>

<script>
import moment from 'moment'

export default {
    name: 'EstadisticaPrincipal',
    
    data() {
        return {
            reporteActivo: [],
            reportes: [
                {
                    id: 20,
                    name: 'Estadística',
                    icon: 'mdi-chart-bar',
                    children: [
                        {
                            id: 201,
                        name: 'S.I.S.',
                            icon: 'mdi-hospital-building'
                    },
                    {
                            id: 202,
                        name: 'Estudios',
                            icon: 'mdi-file-document-multiple'
                    },
                    {
                            id: 203,
                        name: 'Egresos',
                            icon: 'mdi-logout'
                    },
                    {
                            id: 204,
                        name: 'Urgencias',
                            icon: 'mdi-alert-circle'
                    },
                    {
                            id: 205,
                        name: 'Lesiones',
                            icon: 'mdi-hospital-box'
                    },
                    {
                            id: 206,
                        name: 'Defunciones',
                            icon: 'mdi-cross'
                    },
                ]
            },
            {
                    id: 30,
                    name: 'Reportes',
                    icon: 'mdi-file-chart',
                    children: [
                        {
                            id: 301,
                        name: 'Movimientos',
                            icon: 'mdi-swap-horizontal'
                    },
                    {
                            id: 302,
                        name: 'Espera CONSULTA',
                            icon: 'mdi-clock-time-four'
                    },
                    {
                            id: 303,
                        name: 'Espera URGENCIAS',
                            icon: 'mdi-alarm'
                    },
                    {
                            id: 304,
                            name: 'Cirugías',
                            icon: 'mdi-scissors-cutting'
                    },
                ]
            },
            ],
            estadisticasResumen: [
                {
                    icon: 'mdi-hospital-building',
                    label: 'S.I.S.',
                    value: 'Activo',
                    color: '#1565c0'
                },
                {
                    icon: 'mdi-file-document-multiple',
                    label: 'Reportes',
                    value: '10+',
                    color: '#1565c0'
                },
                {
                    icon: 'mdi-chart-line',
                    label: 'Estadísticas',
                    value: 'Disponibles',
                    color: '#1565c0'
                },
                {
                    icon: 'mdi-database',
                    label: 'Sistema',
                    value: 'Actualizado',
                    color: '#1565c0'
                }
            ],
            reportesAccesoRapido: [
                {
                    id: 301,
                    titulo: 'Movimientos',
                    descripcion: 'Consulta de movimientos',
                    icon: 'mdi-swap-horizontal',
                    color: '#1565c0'
                },
                {
                    id: 302,
                    titulo: 'Espera Consulta',
                    descripcion: 'Tiempos de espera',
                    icon: 'mdi-clock-time-four',
                    color: '#1565c0'
                },
                {
                    id: 303,
                    titulo: 'Espera Urgencias',
                    descripcion: 'Atención urgente',
                    icon: 'mdi-alarm',
                    color: '#1565c0'
                },
                {
                    id: 304,
                    titulo: 'Cirugías',
                    descripcion: 'Reporte de cirugías',
                    icon: 'mdi-scissors-cutting',
                    color: '#1565c0'
                }
            ]
        }
    },
    
    computed: {
        fechaActual() {
            return moment().format('DD/MM/YYYY')
        },
        nombreUsuario() {
            return this.$store.getters['security/username'] || ''
        },
        totalReportes() {
            return this.reportes.reduce((total, categoria) => {
                return total + (categoria.children ? categoria.children.length : 0)
            }, 0)
        },
        reportesConIconos() {
            return this.reportes.map(reporte => {
                const children = reporte.children ? reporte.children.map(child => ({
                    ...child,
                    icon: child.icon || 'mdi-circle-small'
                })) : []
                return {
                    ...reporte,
                    icon: reporte.icon || 'mdi-folder',
                    children
                }
            })
        }
    },
    
    methods: {
        navegarAReporte(route) {
            if (route) {
                this.$router.push({ path: route }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Error de navegación:', err)
                    }
                })
            }
        },
        seleccionarReporteRapido(reporte) {
            this.reporteActivo = [reporte.id]
        },
        regresar() {
            this.reporteActivo = []
            this.$router.push({ path: '/estadistica' }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error('Error de navegación:', err)
                }
            })
        },
        obtenerNombreReporteActivo() {
            if (!this.reporteActivo.length) return 'Módulo de Estadística'
            
            const reporteId = this.reporteActivo[0]
            
            // Buscar en todas las categorías
            for (const categoria of this.reportes) {
                if (categoria.children) {
                    const encontrado = categoria.children.find(child => child.id === reporteId)
                    if (encontrado) {
                        return encontrado.name
                    }
                }
            }
            
            return 'Reporte'
        }
    },
    
    watch: {
        reporteActivo(newVal) {
            if (newVal && newVal.length > 0) {
                const reporteId = newVal[0]
                
                const rutas = {
                    201: '/estadistica/consutasis',
                    202: '/estadistica/estudiosis',
                    301: '/estadistica/estadisticaPacientes/listado',
                    302: '/estadistica/estadisticaPacientes/esperaConsulta',
                    303: '/estadistica/estadisticaPacientes/esperaUrgencias',
                    304: '/estadistica/estadisticaPacientes/cirugias'
                }
                
                if (rutas[reporteId]) {
                    this.navegarAReporte(rutas[reporteId])
                }
            }
        }
    },
    
    mounted() {
        // Componente inicializado
    }
}
</script>

<style scoped>
.estadistica-container {
    min-height: 100vh;
    background-color: #f5f5f5;
}

.estadistica-header {
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.3) !important;
}

.estadistica-title {
    font-family: 'Montserrat', sans-serif;
    font-weight: 900;
    font-size: 1.5rem;
    letter-spacing: 0.5px;
}

.content-sheet {
    margin-top: 0;
    background-color: #ffffff;
    border-radius: 0;
}

.full-height {
    min-height: calc(100vh - 64px);
}

/* Panel de navegación mejorado */
.navigation-panel {
    background-color: #fafafa;
    border-right: 2px solid #e0e0e0;
    padding: 12px;
}

.navigation-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    overflow: hidden;
}

.navigation-header {
    background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
    padding: 20px 16px;
    color: white;
}

.navigation-header-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.navigation-header-icon {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    padding: 8px;
}

.navigation-header-text {
    flex: 1;
}

.navigation-title-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.1rem;
    font-weight: 900;
    margin: 0;
    color: white;
    letter-spacing: 0.5px;
}

.navigation-subtitle-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.75rem;
    margin: 4px 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 400;
}

.navigation-divider {
    margin: 0;
    border-color: rgba(255, 255, 255, 0.2);
}

.navigation-content {
    max-height: calc(100vh - 280px);
    overflow-y: auto;
    padding: 12px 8px !important;
}

.custom-treeview {
    padding: 4px 0;
}

/* Estilos para categorías (padres) */
.treeview-item-category {
    margin: 8px 0;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.treeview-category-content {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    width: 100%;
}

.treeview-category-main-icon {
    background: #e3f2fd;
    border-radius: 8px;
    padding: 8px;
    transition: all 0.3s ease;
}

.treeview-item-category:hover .treeview-category-main-icon {
    background: #bbdefb;
    transform: scale(1.1);
}

.treeview-category-name {
    flex: 1;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.95rem;
    font-weight: 700;
    color: #424242;
    letter-spacing: 0.3px;
}

.treeview-item-count {
    font-weight: 600;
    min-width: 28px;
    justify-content: center;
}

/* Estilos para subitems (hijos) */
.treeview-item-inactive,
.treeview-item-active {
    margin: 4px 0;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.treeview-item-inactive {
    background: transparent;
}

.treeview-item-active {
    background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
    box-shadow: 0 4px 12px rgba(21, 101, 192, 0.3);
    transform: translateX(4px);
}

.treeview-subitem-content {
    display: flex;
    align-items: center;
    padding: 10px 16px 10px 48px;
    width: 100%;
    position: relative;
}

.treeview-subitem-content::before {
    content: '';
    position: absolute;
    left: 32px;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #90caf9;
    transition: all 0.3s ease;
}

.treeview-item-active .treeview-subitem-content::before {
    background: white;
    width: 8px;
    height: 8px;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.treeview-subitem-name {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    color: #616161;
    font-weight: 500;
    transition: all 0.3s ease;
}

.treeview-item-active .treeview-subitem-name {
    color: white;
    font-weight: 600;
}

.treeview-item-inactive:hover {
    background: #f5f5f5;
    transform: translateX(4px);
}

.treeview-item-inactive:hover .treeview-subitem-name {
    color: #1565c0;
}

.treeview-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.navigation-footer {
    padding: 12px 16px;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
}

.navigation-footer-divider {
    margin: 0;
}

.footer-chip {
    width: 100%;
    justify-content: center;
    font-weight: 600;
}

/* Panel de contenido */
.content-panel {
    background-color: #fafafa;
}

.content-card {
    padding: 24px;
    border-radius: 0;
}

/* Pantalla de bienvenida mejorada */
.welcome-screen {
    padding: 40px 24px;
    min-height: 600px;
}

.welcome-header {
    text-align: center;
    margin-bottom: 40px;
}

.welcome-icon-container {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
}

.welcome-main-icon {
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    border-radius: 50%;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(21, 101, 192, 0.2);
}

.welcome-saludo {
    font-family: 'Montserrat', sans-serif;
    color: #333;
    font-size: 2.5rem;
    font-weight: 900;
    margin-bottom: 12px;
    letter-spacing: 0.5px;
}

.welcome-subtitle {
    font-family: 'Montserrat', sans-serif;
    color: #666;
    font-size: 1.3rem;
    font-weight: 500;
    margin-bottom: 24px;
}

.welcome-divider {
    max-width: 200px;
    margin: 0 auto;
    border-color: #1565c0;
    border-width: 2px;
}

.welcome-content {
    margin-top: 32px;
}

.welcome-info {
    margin-bottom: 24px;
}

.info-card {
    border-radius: 12px;
    border-top: 4px solid #1565c0;
    height: 100%;
}

.info-card-title {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: #333;
    padding: 16px 20px;
}

.info-text {
    font-family: 'Montserrat', sans-serif;
    color: #555;
    line-height: 1.6;
    margin-bottom: 16px;
    font-size: 1rem;
}

.welcome-stats {
    margin-bottom: 24px;
}

.quick-stats-card {
    border-radius: 12px;
    border-top: 4px solid #1565c0;
    height: 100%;
}

.quick-stats-title {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: #333;
    padding: 16px 20px;
}

.quick-stat-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #e0e0e0;
}

.quick-stat-item:last-child {
    border-bottom: none;
}

.quick-stat-icon {
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #e3f2fd;
    border-radius: 8px;
}

.quick-stat-content {
    flex: 1;
}

.quick-stat-value {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.2rem;
    font-weight: 900;
    color: #1565c0;
    margin-bottom: 4px;
}

.quick-stat-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
}

.welcome-cards {
    margin-top: 32px;
}

.acceso-rapido-card {
    border-radius: 12px;
    border-top: 4px solid #1565c0;
    cursor: pointer;
    transition: all 0.3s ease;
    height: 100%;
}

.acceso-rapido-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 20px rgba(21, 101, 192, 0.3) !important;
    border-top-color: #0d47a1;
}

.acceso-rapido-titulo {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.1rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
}

.acceso-rapido-descripcion {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.85rem;
    color: #666;
    font-weight: 400;
}

.stats-summary {
    width: 100%;
    max-width: 900px;
    margin-top: 32px;
}

.stat-card {
    border-radius: 8px;
    transition: all 0.3s ease;
    border-top: 4px solid #1565c0;
    margin-bottom: 16px;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(21, 101, 192, 0.2) !important;
}

.stat-value {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.5rem;
    font-weight: 900;
    color: #1565c0;
    margin: 8px 0;
}

.stat-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    color: #666;
    font-weight: 500;
}

/* Contenido de reportes */
.report-content {
    padding: 0;
    min-height: 500px;
}

/* Transiciones */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter {
    opacity: 0;
    transform: translateX(20px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}

/* Responsive */
@media (max-width: 960px) {
    .navigation-panel {
        border-right: none;
        border-bottom: 2px solid #e0e0e0;
    }
    
    .welcome-saludo {
        font-size: 2rem;
    }
    
    .welcome-subtitle {
        font-size: 1.1rem;
    }
    
    .estadistica-title {
        font-size: 1.2rem;
    }
    
    .stats-summary {
        margin-top: 24px;
    }
    
    .welcome-screen {
        padding: 24px 16px;
    }
}

@media (max-width: 600px) {
    .welcome-screen {
        padding: 20px 12px;
        min-height: auto;
    }
    
    .welcome-saludo {
        font-size: 1.5rem;
    }
    
    .welcome-subtitle {
        font-size: 1rem;
    }
    
    .welcome-main-icon {
        padding: 16px;
    }
    
    .content-card {
        padding: 12px;
    }
    
    .rango-info {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .rango-info .v-chip,
    .rango-info .v-btn {
        margin: 4px 0;
    }
}

/* Scrollbar y estilos profundos del treeview */
.custom-treeview ::v-deep .v-treeview-node {
    margin: 0;
}

.custom-treeview ::v-deep .v-treeview-node__root {
    padding: 0;
}

.custom-treeview ::v-deep .v-treeview-node__content {
    border-radius: 0;
    padding: 0;
    min-height: auto;
    margin: 0;
}

.custom-treeview ::v-deep .v-treeview-node__children {
    padding-left: 24px;
}

.custom-treeview ::v-deep .v-treeview-node--leaf {
    margin-left: 0;
}

/* Scrollbar personalizado */
.navigation-content::-webkit-scrollbar {
    width: 6px;
}

.navigation-content::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
}

.navigation-content::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 10px;
}

.navigation-content::-webkit-scrollbar-thumb:hover {
    background: #9e9e9e;
}
</style>